module.exports = __webpack_public_path__ + "img/槐角.9e1f7861.jpg";